import {
  APIProvider,
  Map,
  AdvancedMarker,
  /* useAdvancedMarkerRef,
  useMap,
  useMapsLibrary,
  ControlPosition,
  MapControl, */
  Pin,
} from "@vis.gl/react-google-maps";
import useAddressContext from "../../hooks/useAddressContext";
import useArtisanContext from "../../hooks/useArtisanContext";

export const googleMapApiKey = "AIzaSyD84BvnJGsGjKWLXVUHYJ1DidTvafy7cAw";
export const googleMapId = "6c9f551e62d5c50a";

const ProvidersLocationMap = () => {
  const { currentCoordinate } = useAddressContext();
  const { availableService } = useArtisanContext();

  return (
    <APIProvider apiKey={googleMapApiKey}>
      <div className="absolute inset-0">
        <Map
          style={{ width: "100%", height: "100%" }}
          center={currentCoordinate}
          zoom={14}
          zoomControl={true}
          streetViewControl={false}
          mapTypeControl={false}
          mapId={googleMapId}
          fullscreenControl={false}
          gestureHandling="greedy"
          //disableDefaultUI={true}
        >
          <div
            className="absolute"
            style={{
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              pointerEvents: "none",
            }}
          >
            <span className="relative flex h-36 w-36">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teriary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-36 w-36 bg-[#15abbc] opacity-20"></span>
            </span>
          </div>

          <AdvancedMarker position={currentCoordinate}>
            <Pin
              background={"#0EA5E9"}
              borderColor={"white"}
              glyphColor={"white"}
            />
          </AdvancedMarker>

          {availableService?.services?.map((response) => (
            <AdvancedMarker
              key={response?.id}
              position={{
                lat: response?.artisan?.latitude,
                lng: response?.artisan?.longitude,
              }}
            >
              <Pin
                background={"#15abbc"}
                borderColor={"#15abbc"}
                glyphColor={"#233D4A"}
              />
            </AdvancedMarker>
          ))}
        </Map>
      </div>
    </APIProvider>
  );
};

export default ProvidersLocationMap;
